import React from "react";
import { Route } from "react-router-dom";
import AccessControl from "../../../components/utilities/Class/AccessControl";
import WarehouseIn from "../../../containers/modules/warehouse/warehouse-in";

export default function WarehouseInRoute(props) {
  const { authUser } = props;
  return (
    <Route
      path="warehouse-in"
      index
      element={
        <AccessControl
          name={"Warehouse In List"}
          auth={authUser}
          component={() => <WarehouseIn />}
        />
      }
    />
  );
}
